import type { ReactNode } from "react";

type Props = { title: ReactNode; subtitle?: ReactNode; right?: ReactNode };

export function PageHeader({ title, subtitle, right }: Props) {
  return (
    <div className="t-page-header">
      <div>
        <h1>{title}</h1>
        {subtitle && <div className="subtitle">{subtitle}</div>}
      </div>
      {right && <div style={{ display: "flex", gap: 8 }}>{right}</div>}
    </div>
  );
}
